import { Box, useTheme } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import type { FC } from 'react';

import { PositionAnimationVariants } from './data/PositionAnimationVariants';
import { PositionStyles } from './data/PositionStyles';
import { ToastAlert } from './ToastAlert';
import type {
  Toast,
  ToastAlertPosition,
  ToastContextProps,
  ToastProviderConfig,
} from './ToastContext';

interface ToastContainerProps {
  data: Toast[];
  removeAlert: ToastContextProps['removeAlert'];
  config: ToastProviderConfig;
  position: ToastAlertPosition;
}

export const ToastContainer: FC<ToastContainerProps> = ({
  data,
  config,
  position,
  removeAlert,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        position: 'fixed',
        pointerEvents: 'none',
        zIndex: theme.zIndex.snackbar,
        ...PositionStyles[position],
      }}
    >
      <AnimatePresence>
        {data.map(({ id, ...props }) => (
          <motion.div
            key={id}
            layout
            style={{ pointerEvents: 'all' }}
            variants={PositionAnimationVariants[position]}
            initial='initial'
            animate='animate'
            exit='exit'
            transition={{ duration: 0.3, ease: 'easeOut' }}
          >
            <ToastAlert id={id} providerConfig={config} removeAlert={removeAlert} {...props} />
          </motion.div>
        ))}
      </AnimatePresence>
    </Box>
  );
};
